<template>
  <div class="container-fluid navigation-bar p-1 px-2">
    <button @click="toggle" class="burger">
      <font-awesome-icon icon="fa-solid fa-bars"/>
    </button>

    <div class="navbar-logo"></div>
    <div class="navigation-box">
      <RequestsPending ref="audioPlayer" />
    </div>

    <div class="user-settings">
      <button @click="syncData" class="burger">
        <font-awesome-icon icon="fa-solid fa-arrows-rotate"/>
      </button>
    </div>
  </div>
</template>

<script>


import RequestsPending from "@/components/RequestsPending";
export default {
  name: "NavigationBar",
  components: {RequestsPending},
  beforeMount() {
    this.checkRequests()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.checkRequests();
    }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  props: {
    toggle: {
      type: Function,
      require: true
    },
  },
  methods: {
    syncData() {
      this.$utils.showLoading();
      return window.location.reload(true);
    },
    playSound() {
      let currentCount = this.$store.getters.getTotalRequestCount;
      showNotification(`Sign ups Requests pending`,`There are ${currentCount} sign up requests pending , Please review them in a timely manner`)
      this.$refs.audioPlayer.playNotificationSound();
    },
    checkRequests() {
      return this.$store.dispatch(`getRequestCounts`).then(res => {
        try {
          document.getElementById(`interact-btn`).click();
        } catch (e) {
        }
        if (res) return this.playSound();
      });
    },
  }
}
</script>

<style scoped>
.burger {
  width: 40px;
  height: 40px;
  background: transparent;
  color: white;
  font-size: 30px;
}

.user-settings {
  display: flex;
  flex-direction: row;
  justify-content: end;
}
</style>
